import { render } from "./ScoreNode.vue?vue&type=template&id=be2ca06e&scoped=true"
import script from "./ScoreNode.vue?vue&type=script&lang=js"
export * from "./ScoreNode.vue?vue&type=script&lang=js"

import "./ScoreNode.vue?vue&type=style&index=0&id=be2ca06e&scoped=true&lang=css"

import exportComponent from "/home/rich/web/spelling-bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be2ca06e"]])

export default __exports__